import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { Loader } from "@devhop/ui";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import brandMark from "@/assets/icon.png";

export function AuthLayout() {
  const { isLoading, isAuthenticated } = useAuthState();
  const navigate = useNavigate({ from: "/auth" });

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: "/app/dashboard" });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-svh max-w-none items-center justify-center">
        <Loader />
      </div>
    );
  }
  return (
    <div className="flex h-svh max-w-none items-center justify-center">
      <div className="mx-auto flex w-full max-w-md flex-col justify-center space-y-2 py-8 sm:p-8">
        <div className="mb-4 flex items-center justify-center">
          <img
            src={
              typeof brandMark === "string"
                ? brandMark
                : ((brandMark as { default?: string })?.default ?? "")
            }
            alt="Logo"
            className="me-2 h-8 w-8"
          />
          <h1 className="font-medium text-xl">Life Football CF</h1>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
